






























































import { Component, Vue, Watch } from "vue-property-decorator";
import api from "../../api/index";
import { VueReCaptcha } from "vue-recaptcha-v3";
Vue.use(VueReCaptcha, { siteKey: process.env.VUE_APP_GOOGLE_RECAPTCHA_KEY });

@Component({
  components: {},
})
export default class Openings extends Vue {
  apiErrorMessage = "";
  apiError = false;
  success = false;
  canOpen = true;
  number = "";
  badge = null;
  opened_door_id = null;
  opening_delay = 5000;

  async mounted() {
    await api.init();
    try {
      this.number = this.$route.params.number;
      const res = await api.get(`internal/access_codes/${this.number}`);
      this.badge = res.data;
    } catch (e) {
      if (e.response.status === 422) {
        this.apiErrorMessage = e.response.data.errors[0];
        this.apiError = true;
      } else {
        this.apiErrorMessage = "Votre groupe n’est plus valide.";
        this.apiError = true;
      }
    }
  }

  async recaptcha() {
    // @ts-ignore
    await this.$recaptchaLoaded();
    // @ts-ignore
    const token = await this.$recaptcha("login");
    return token ? token : false;
  }

  async openDoor(id) {
    this.apiError = false;
    this.apiErrorMessage = "";
    const token = await this.recaptcha();
    if (token && this.canOpen) {
      try {
        this.canOpen = false;
        const res = await api.post(
          `internal/access_codes/${this.number}/access_points/${id}/openings`,
          {
            t: token,
          }
        );
        if (res.status === 201) {
          this.opened_door_id = id;
          this.success = true;
          setTimeout(() => {
            this.opened_door_id = null;
            this.success = false;
          }, this.opening_delay);
        }
      } catch (error) {
        if (error.response.status === 503) {
          this.apiErrorMessage = error.response.data.errors[0];
          this.apiError = true;
        }
      }
    }
  }

  @Watch("canOpen")
  onOpenChanged(val) {
    if (val === false) {
      setTimeout(() => {
        this.canOpen = true;
      }, this.opening_delay);
    }
  }
}
